// src/components/Footer.tsx
import React from 'react';
import styled from 'styled-components';
import { FaLinkedin, FaGithub, FaHeart, FaEnvelope } from 'react-icons/fa';

const FooterContainer = styled.footer`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.2rem;
  padding: 2.8rem 2rem;
  background: #030305;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 10%;
    right: 10%;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(139,92,246,0.5), rgba(34,197,94,0.3), transparent);
  }
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 1rem;

  a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 1px solid rgba(255, 255, 255, 0.08);
    color: ${(props) => props.theme.colors.muted};
    font-size: 1rem;
    transition: all 0.3s ease;
    text-decoration: none;

    &:hover {
      color: ${(props) => props.theme.colors.accentLight};
      border-color: rgba(139, 92, 246, 0.45);
      background: rgba(139, 92, 246, 0.08);
      transform: translateY(-3px);
    }
  }
`;

const Copyright = styled.p`
  font-size: 0.82rem;
  color: ${(props) => props.theme.colors.muted};
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin: 0;

  svg {
    color: #a78bfa;
    font-size: 0.65rem;
  }
`;

const Footer: React.FC = () => (
  <FooterContainer>
    <SocialIcons>
      <a href="https://www.linkedin.com/in/igor-chrzyptowicz-3183911b7/" target="_blank" rel="noopener noreferrer">
        <FaLinkedin />
      </a>
      <a href="https://github.com/IgorLTS10" target="_blank" rel="noopener noreferrer">
        <FaGithub />
      </a>
      <a href="mailto:igorchrzyptowicz@gmail.com">
        <FaEnvelope />
      </a>
    </SocialIcons>
    <Copyright>
      © 2026 Igor Chrzyptowicz — Built with <FaHeart /> and React
    </Copyright>
  </FooterContainer>
);

export default Footer;
